// extracted by mini-css-extract-plugin
module.exports = {"selectTaxRateWindow":"selectTaxRateWindow__EUeID"};